import Vue from 'vue'
import Vuex from 'vuex'
import Login from '@/views/PC/Login/store.js'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        Login,
    },
    state: {
        /* 主题 */
        theme: { id: 2, name: '淡色', themeData: 'light', color: '#ECF2FD' }, // 当前主题
        themeList: [  // 主题列表
            { id: 2, name: '淡色', themeData: 'light', color: '#ECF2FD' },
            { id: 3, name: '绿色', themeData: 'green', color: '#1EAF3B' },
            //   { id: 5, name: '黑色', themeData: 'black', color: '#121924' },
        ],
        userInfo: {
            userName: '',
            isMobileFlag: false,
        },
        pageNo: '',

    },

    actions: {

        /* 主题 */
        themeChange(s, t) {
            let b = document.getElementById('body')
            b.setAttribute('data-theme', t.themeData)
            localStorage.setItem('bs-theme', JSON.stringify(t))
            s.commit('THEME', t)  // 设置主题
        },

        delLocal() {
            localStorage.setItem('projectId', '')
            localStorage.setItem('projectCoordinates', '')
            localStorage.setItem('state', '')
            localStorage.removeItem('appToken')
        },
    },
    mutations: {
        THEME(s, d) {  // 主题
            s.theme = d
        },
        ROLE_MENU_OPERATION(s, d) {  // 权限
            s.roleMenuOperation = d
        },
        PROJECT_ID(s, d) { // 项目ID
            s.projectId = d
        },
        'Login/USER_INFO'(s, d) {
            s.userName = d.uid
        },
        CHANGE_PAGE_NO(s, d) {
            s.pageNo = d
        }
    }
})
